import './Separator.scss';

export const Separator = () => <hr className="separator mb-4" />;
